import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAppDispatch } from "../../../../../hooks/hooks";
import PageLoader from "../../../../../components/PageLoader";
import Table from "../../../../../common/components/table-manager/v1.1/table";
import { brandMappings } from "../../../../../redux/brand-mappings/action";
import { selectBrandMappingsListItems } from "../../../../../redux/brand-mappings/selector";
import { selectListItems } from "../../../../../redux/library/selector";

const ManagementBrandMappings = () => {
    const dispatch = useAppDispatch()
    const navigate = useNavigate()
    const [pageData, setPageData] = useState(1)
    const [pageSize, setPageSize] = useState(10);
    const libraryData = useSelector(selectListItems)
    const brandMappingsListData = useSelector(selectBrandMappingsListItems)
    const [columnDefs, setColumnDefs] = useState({});

    const createColumnDefs: any = () => {
        setColumnDefs([
            {
                field: 'Sl',
                sortable: false,
                filter: false,
                isSortLabel: true,
                headerName: 'Sl',
                cellRenderer(params: any) {
                    return parseInt(
                        params.node.id,
                        10
                    ) + 1;
                },
            },
            {
                field: 'Configurations.Logos[0].Url',
                headerName: 'Image',
                sortable: false,
                filter: false,
                cellRenderer: 'imageRenderer',
                filterType: 'text',
                isEdit: true,
            },
            { field: 'Name', headerName: 'Name', searchField: 'Name', sortable: true, filter: true, filterType: 'text' },
            { field: 'OwnerType', headerName: 'Owner Type', searchField: 'OwnerType', sortable: true, filter: true, filterType: 'text' },
            { field: 'CreatedOnUtc', headerName: 'Created On', isDateValueFormat: true },
        ]);
    }

    const handleAdd = () => {
        navigate(`${0}`)
    }

    const handleEdit = (data: any) => {
        navigate(`${data?.Id}`)
    }

    const handleDelete = (data: any) => {
        dispatch(brandMappings.delete({
            url: `https://cms.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/cms/brand-mappings/delete`,
            entity: 'brandMappings',
            jsonData:
            {
                Records: [
                    {
                        Id: data?.Id
                    }
                ]
            }
        })).then(() => {
            fetchBrandMappingsList();
        });
    }

    const additionButtons: any = [
        {
            svg:
                <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24" width="24" height="24">
                    <title>Add Brand Mapping</title>
                    <path d="M12 5v14m-7-7h14" stroke="currentColor" stroke-width="2" fill="none" />
                </svg>,
            callback: () => handleAdd(),
        },
        {
            svg:
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" width="24" height="24">
                    <title>Reload this table</title>
                    <path d="M21 3V8M21 8H16M21 8L18 5.29168C16.4077 3.86656 14.3051 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.2832 21 19.8675 18.008 20.777 14" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                </svg>,
            callback: () => handleReloadData(),
        },
    ];

    const fetchBrandMappingsList = () => {
        dispatch(brandMappings.list({
            url: `https://cms.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/cms/brand-mappings/list`,
            entity: 'brandMappings',
            jsonData:
            {
                "PageNumber": pageData,
                "PageSize": pageSize,
                "SortField": "CreatedOnUtc",
                "SortOrder": "desc",
            }
        }))
    }

    useEffect(() => {
        createColumnDefs()
        fetchBrandMappingsList()
    }, [pageData, pageSize])

    const handleReloadData = () => {
        fetchBrandMappingsList();
    }

    const handleSearch = (data: any) => {
        let searchCriteria = {};
        if (data?.column) {
            searchCriteria = [{
                FieldName: data?.column,
                FieldText: data?.column,
                FieldType: 'text',
                FilterOperatorId: 6,
                FieldValue: data?.value
            }]
        } else {
            searchCriteria = [{
                FieldName: "Name",
                FieldText: "Name",
                FieldType: 'text',
                FilterOperatorId: 6,
                FieldValue: data?.value
            }]
        }
        dispatch(brandMappings.list({
            url: `https://cms.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/cms/brand-mappings/list`,
            entity: 'brandMappings',
            jsonData:
            {
                "PageNumber": pageData,
                "PageSize": pageSize,
                "SortField": "Id",
                "SortOrder": "desc",
                "Searches": searchCriteria,
            }
        }));
    }

    return (
        <>
            {brandMappingsListData?.isLoading ? <PageLoader /> :
                <Table
                    columnData={columnDefs} rowData={brandMappingsListData?.result?.items}
                    setPageData={setPageData} setPageSize={setPageSize} paginationData={brandMappingsListData?.result?.pagination}
                    enableFilter={true} onSearch={handleSearch}
                    checkboxConfig={{
                        allowMultiSelect: true,
                        defaultSelectedIds: [],
                        isDisabled: false,
                        keyColumn: 'Id',
                    }}
                    onEdit={handleEdit} onDelete={handleDelete} additionButtons={additionButtons}
                    headingName="Brand Mappings"
                />
            }
        </>
    );
};

export default ManagementBrandMappings;


